/* ============
 * Create Page
 * ============
 *
 * This is the page for adding campaign.
 */
import { mapGetters } from 'vuex';
import campaignService from './../../../../services/campaign';
import campaignTypeService from './../../../../services/campaignType';
import subscriberListService from './../../../../services/subscriberList';
import campaignTransformer from './../../../../transformers/campaign';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        campaignTypeId: {
          value: '',
          type: 'select',
        },
        newsSubscriberListId: {
          value: '',
          type: 'select',
        },
      }),
    };
  },

  computed: {
    ...mapGetters({
      campaignTypes: 'campaignTypes',
      allSubscriberList: 'allSubscriberList',
    }),
  },

  watch: {
    /**
     * Watches campaign types to inject on form.
     *
     * @param {Array} campaignTypes Types of campaign.
     */
    campaignTypes(campaignTypes) {
      this.form.setOptions('campaignTypeId', campaignTypes);
    },

    /**
     * Watches allSubscriberList to inject on form.
     *
     * @param {Array} allSubscriberList Types of campaign.
     */
    allSubscriberList(allSubscriberList) {
      this.form.setOptions('newsSubscriberListId', allSubscriberList.items);
    },
  },

  created() {
    subscriberListService.all();
    campaignTypeService.all();
    this.form.setTooltip('campaignTypeId', this.$t('static.campaigns.create.campaignTypeTooltip'));
  },

  methods: {
    /**
     * Method to store the campaign.
     */
    store() {
      this.form.loading = true;
      const campaign = campaignTransformer.send(this.form.data());
      campaignService.store(campaign)
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/campaigns/create/create.js